import { render, staticRenderFns } from "./leftCategory.vue?vue&type=template&id=1f82436a&scoped=true"
import script from "./leftCategory.vue?vue&type=script&lang=js"
export * from "./leftCategory.vue?vue&type=script&lang=js"
import style0 from "./leftCategory.vue?vue&type=style&index=0&id=1f82436a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82436a",
  null
  
)

export default component.exports